import { render, staticRenderFns } from "./NoteNotSelected.vue?vue&type=template&id=528e218b&scoped=true&"
import script from "./NoteNotSelected.vue?vue&type=script&lang=js&"
export * from "./NoteNotSelected.vue?vue&type=script&lang=js&"
import style0 from "./NoteNotSelected.vue?vue&type=style&index=0&id=528e218b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e218b",
  null
  
)

export default component.exports